import React, { memo } from "react";
import { CCollapse } from "@coreui/react";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

export const Info = memo(function Info({ data = {} }) {
  let { stores, locations, regions, users, reports } = data;

  if (Object.keys(data).length === 0) {
    return <LoadingAnimation />;
  }

  return (
    <>
      <CCollapse show>
        <div className="admin-organizations__expanded">
          <InfoItem item={stores} title="Stores" />
          <InfoItem item={locations} title="Locations" />
          <InfoItem
            item={regions}
            title="Regions"
            renderItem={(el) => (
              <div key={el} style={{ fontWeight: el.includes("(Default)") ? "bold" : "normal" }}>
                {el}
              </div>
            )}
          />
          <InfoItem
            item={users}
            title="Users"
            renderItem={(el) => {
              let userName = el.split(/(?=\(Not Active\))/);
              return (
                <div key={el}>
                  {userName[0]}
                  {userName[1] ? <span style={{ color: "red" }}>{userName[1]}</span> : ""}
                </div>
              );
            }}
          />
          <InfoItem item={reports} title="Reports" />
        </div>
      </CCollapse>
    </>
  );
});

const InfoItem = ({ item, title, renderItem }) => {
  let render = (el) => <div key={el}>{el}</div>;

  return (
    <div>
      <p>
        {title} ({item.length}):
      </p>
      {item.map(renderItem ? renderItem : render)}
    </div>
  );
};
